import { render, staticRenderFns } from "./MagazzinoTipoDocumentoModalEditComponent.vue?vue&type=template&id=0131b6a9"
import script from "./MagazzinoTipoDocumentoModalEditComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoTipoDocumentoModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports